























































import * as TWEEN from "@tweenjs/tween.js";
import Bubble from "./Bubble.vue";
import GameStart from "./GameStart.vue";
import GameEnd from "./GameEnd.vue";
import GameInfo from "./GameInfo.vue";
import GameCredit from "./GameCredit.vue";
import GameRank from "./GameRank.vue";
import GameStartBtn from "./GameStartBtn.vue";

import Bar from "./Bar.vue";
import { Component, Vue } from "vue-property-decorator";
import * as THREE from "three";
import NOBCMain from "./nobc";
// @ts-ignore
import Stats from "stats.js";
// @ts-ignore
import * as dat from "three/examples/jsm/libs/dat.gui.module";

import { log, Vector3 } from "three";
@Component({
  name: "ONP",
  components: {
    Bubble,
    Bar,
    GameEnd,
    GameStart,
    GameStartBtn,
    GameRank,
    GameInfo,
    GameCredit
  },
})
export default class ONP extends Vue {
  private camera!: THREE.OrthographicCamera;
  private renderer!: THREE.WebGLRenderer;
  private scene: THREE.Scene = new THREE.Scene();
  private sceneNoEffect: THREE.Scene = new THREE.Scene();
  private cube!: NOBCMain;
  private vec = new THREE.Vector3();
  private canvas!: HTMLCanvasElement;
  //private gui = new dat.GUI();
  private isGuiInit = false;
  private targetWidth = 18;
  private targetHeight = 32;
  public frameImg = new Image();
  public frameURL = require(`../../assets/onp/site/Group139.png`);

  public OnCloseBubble(bubble: Bubble) {
    bubble.$props.bubbleData.display = false;
  }

  private OnInfoClose() {
    if (this.showInfoPopup) {
      this.showInfoPopup = false;
    }
  }
  private OnCreditClose() {
    if (this.showCreditPopup) {
      this.showCreditPopup = false;
    }
  }
  
  private OnRankClose() {
    if (this.showRankPopup) {
      this.showRankPopup = false;
    }
  }
  private OnInfoLink(idx: number) {
    //console.log("LINK", idx);
    switch (idx) {
      case 0:
        window.open("https://www.instagram.com/greenplayonline", "_blank");
        break;
      case 1:
        window.open("https://open.kakao.com/o/gQsWy4cd", "_blank");
        break;
      case 2:
        window.open("https://discord.gg/PQGKpVCY4H", "_blank");
        break;
      case 3:
        window.open("https://greenplay.online/", "_blank");
        break;
    }
  }
  private OnScore(score: number) {
    this.$emit("score", score);
  }
  public GetGameEndCanvas() {
    var target: any = this.$refs.gameEnd;
    return target.canvas;
  }
  private OnReplay() {
    this.cube.board.isDemo = true;
    this.showEndPopup = false;
      this.bar.setColorBack();

    this.cube.ResetGame();
    this.bar.setHeart(this.cube.life);
    this.bar.setProgress(0, this.addCommas("0"));
    this.showBar = false;
    this.cube.shouldScroll = true;
    this.cube._scrollSpeed = 0.01;
    this.cube.PlayLoop("main");
  }
  private OnRank() {
    this.showRankPopup = true;
    this.$nextTick((): void => {
      var target: any = this.$refs.gameRank;
      this.$emit("rank", target);
    });
  }
  private OnInfo() {
    this.showInfoPopup = true;
  }
  private OnCredit() {
    this.showCreditPopup = true;
  }
  private startTime = 0;
  private OnStart() {
    this.startTime = new Date().getTime() / 1000;
    this.cube.InitAudio();
    //this.bar.setInfo(1);
    //hide button
    this.cube.ResetGame();
    this.cube._scrollSpeed = 0.002;
    this.cube.shouldScroll = false;
    this.showBar = true;
    this.cube.board.isDemo = false;

    this.cube.StartGame();
  }
  private handleTouchStart(e: TouchEvent) {
    if (!this.showBar || this.cube.isDead) return;
    e.preventDefault();
    for (let i = 0; i < e.changedTouches.length; i++) {
      /*console.log(
        "handleTouchStart:changedTouches[" +
          i +
          "].identifier = " +
          e.changedTouches[i].identifier
      );*/
      this.cube.handleTouchStart(e.changedTouches[i].identifier);
    }
    this.handleTouchMove(e);
  }
  private handleTouchEnd(e: TouchEvent) {
    if (!this.showBar || this.cube.isDead) return;
    e.preventDefault();
    for (let i = 0; i < e.changedTouches.length; i++) {
      /*console.log(
        "handleTouchEnd:changedTouches[" +
          i +
          "].identifier = " +
          e.changedTouches[i].identifier
      );*/
      this.cube.handleTouchEnd(e.changedTouches[i].identifier);
    }
  }

  private handleTouchMove(e: TouchEvent) {
    
    if (!this.showBar || this.cube.isDead) return;
    e.preventDefault();
    const container: HTMLCanvasElement = this.$refs
      .container as HTMLCanvasElement;
    for (let i = 0; i < e.touches.length; i++) {
      this.vec.set(
        (e.touches[i].clientX / container.clientWidth) * 2 - 1,
        -(e.touches[i].clientY / container.offsetHeight) * 2 + 1,
        0
      );
      this.vec.unproject(this.camera);
      this.cube.handleTouchMove(
        e.touches[i].identifier,
        this.vec.x,
        this.vec.y
      );
    }
  }
  private showEndPopup: boolean = false;
  private showInfoPopup: boolean = false;
  private showCreditPopup: boolean = false;
  private showRankPopup: boolean = false;
  private showBar: boolean = false;
  //align-center justify-end
  public data() {
    return {
      showEndPopup: false,
      barData: {
        isCC: true,
        display: true,
      },
      posts: [
        {
          id: 0,
          v: "align-top",
          h: "justify-left",
          content: "",
          display: false,
        },
        {
          id: 1,
          v: "align-top",
          h: "justify-center",
          content: "",
          display: false,
        },
        {
          id: 2,
          v: "align-top",
          h: "justify-end",
          content: "",
          display: false,
        },
        {
          id: 3,
          v: "align-center",
          h: "justify-left",
          content: "",
          display: false,
        },
        {
          id: 4,
          v: "align-center",
          h: "justify-center",
          content: "",
          display: false,
        },
        {
          id: 5,
          v: "align-center",
          h: "justify-end",
          content: "",
          display: false,
        },
        {
          id: 6,
          v: "align-end",
          h: "justify-left",
          content: "",
          display: false,
        },
        {
          id: 7,
          v: "align-end",
          h: "justify-center",
          content: "",
          display: false,
        },
        {
          id: 8,
          v: "align-end",
          h: "justify-end",
          content: "",
          display: false,
        },
      ],
    };
  }

  private bar: any;
  private bubbleStrings!: any;
  private async mounted(): Promise<void> {
    this.bubbleStrings = this.$i18n.t("message.bubble", {
      returnObjects: true,
    });
    this.frameImg.src = this.frameURL;
    this.bar = this.$refs.bar;
    var stats = new Stats();
    stats.showPanel(0); // 0: fps, 1: ms, 2: mb, 3+: custom
    //document.body.appendChild(stats.dom);

    window.addEventListener("resize", this.onWindowResize.bind(this));

    this.canvas = this.$refs.scene as HTMLCanvasElement;
    this.canvas.addEventListener("touchstart", this.handleTouchStart, {
      passive: false,
    });
    this.canvas.addEventListener("touchend", this.handleTouchEnd, {
      passive: false,
    });
    this.canvas.addEventListener("touchcancel", this.handleTouchEnd, {
      passive: false,
    });
    this.canvas.addEventListener("touchmove", this.handleTouchMove);

    this.renderer = new THREE.WebGLRenderer({
      antialias: false,
      stencil: false,
      depth: false,
      canvas: this.canvas,
      preserveDrawingBuffer: false,
    });

    const tRatio = this.targetWidth / this.targetHeight;
    const width = this.canvas.offsetWidth; //Window width
    const height = this.canvas.offsetHeight; //Window height
    const ratio = width / height; //Window aspect ratio

    let w = this.targetWidth * 0.5;
    let h = w / ratio;
    if (ratio < tRatio) {
      h = this.targetHeight * 0.5;
      w = h * ratio;
    }

    this.camera = new THREE.OrthographicCamera(-w, w, h, -h, 1, 1000);

    this.renderer.setPixelRatio(window.devicePixelRatio);
    this.renderer.setSize(width, height);
    this.renderer.setClearColor(0x0, 1);

    this.cube = new NOBCMain(
      this.scene,
      this.scene,
      this.targetWidth,
      this.targetHeight,
      this.camera
    );
    this.cube.OnBubbleShow = this.AddBubble;
    this.cube.OnDead = this.OnDead;
    this.cube.OnBlobEventInfo = (type) => {
      this.bar.setInfo(type);
    };
    this.cube.OnStart = () => {
      this.bar.setInfo(0);
    };
    await this.cube.initScene();
    this.camera.position.z = 10;
    
    // number of touches 3-5
    // size of touch
    // touch wait time 1000
    const animate = (time: any) => {
      requestAnimationFrame(animate);

      stats.begin();
      this.cube.updateScene();
      this.bar.setProgress(
        this.cube.cc,
        this.addCommas(this.cube.cc.toString())
      );

      this.renderer.render(this.scene, this.camera);
      TWEEN.update(time);
      stats.end();
    };

    animate(0);
    this.OnReplay();
  }

  private Screenshot(playTime:number): void {
    var oldCanvas = this.$refs.scene as HTMLCanvasElement;
    var newCanvas = document.createElement("canvas");
    newCanvas.width = 700;
    newCanvas.height = 700;
    var newContext = newCanvas.getContext("2d");

    var width = this.canvas.width;
    var height = this.canvas.height;
    var widthHalf = width / 2,
      heightHalf = height / 2;
    var pos = new Vector3(
      this.cube.blob.centerPoint.x,
      this.cube.blob.centerPoint.y + 6,
      0
    );
    pos.project(this.camera);
    pos.x = pos.x * widthHalf + widthHalf;
    pos.y = -(pos.y * heightHalf) + heightHalf;
    var W = 1100;
    var H = 1100;

    if (W > width) W = width;
    if (H > height) H = height;
    if (W > H) W = H;
    if (H > W) H = W;
    pos.x -= W * 0.5;
    pos.y -= H * 0.5;

    if (pos.x < 0) pos.x = 0;
    if (pos.y < 0) pos.y = 0;
    if (pos.x + W > width) {
      pos.x = width - W;
    }
    if (pos.y + H > height) {
      pos.y = height - H;
    }
    this.renderer.render(this.scene, this.camera);
    newContext?.drawImage(
      oldCanvas,
      pos.x,
      pos.y,
      W,
      H,
      0,
      0,
      newCanvas.width,
      newCanvas.height
    );

    const target: any = this.$refs.gameEnd;
    var date = new Date().toISOString().split("T")[0].replaceAll("-", "/");
    target.setImage(
      newCanvas,
      this.cube.cc,
      this.addCommas(this.cube.cc.toString()),
      date,
      this.frameImg,
      Math.round(playTime)
    );
    target.$el.style["pointer-events"] = "auto";
  }

  private addCommas(nStr: string) {
    nStr += "";
    var x = nStr.split(".");
    var x1 = x[0];
    var x2 = x.length > 1 ? "." + x[1] : "";
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, "$1" + "," + "$2");
    }
    return x1 + x2;
  }
  private getRandomInt(min: number, max: number) {
    let range = max + 1 - min;
    return Math.floor(Math.random() * Math.floor(range)) + min;
  }
  private bubbleZIndex = 100;
  private OnDead(type: number) {
    //if (this.cube.life <= 0) return false;
    //this.cube.life--;
    this.bar.setHeart(this.cube.life);
    //this.bar.setInfo(type == 0 ? 2 : 3);
    if (this.cube.life <= 0) {
      this.cube.EndGame();
      this.cube.PlayLoop("endingsong"); 
      var totaltime = new Date().getTime() / 1000 - this.startTime;
      this.bar.setColor();
      this.cube.Play("gameover_"+ this.getRandomInt(1,2))
      setTimeout(() => {
        this.showEndPopup = true;
        this.$nextTick((): void => {
          const gameEnd: any = this.$refs.gameEnd;
          this.$emit("gameEnd", gameEnd);
          gameEnd.$el.style["pointer-events"] = "none";
          this.Screenshot(totaltime);
        });
      }, 2000);

      return false;
    }
    //console.log("OnDead");

    return true;
  }
  public AddBubble(): void {
    if (!this.showBar) return;
    var availableBubbles = [];
    let bubbleRef: any;
    for (let i = 0; i < 9; i++) {
      bubbleRef = this.$refs["bubbles" + i];
      if (!bubbleRef[0].$props.bubbleData.display) {
        availableBubbles.push(i);
      }
    }
    if (availableBubbles.length > 0) {
      var idx =
        availableBubbles[this.getRandomInt(0, availableBubbles.length - 1)];
      bubbleRef = this.$refs["bubbles" + idx];
      bubbleRef[0].$props.bubbleData.display = true;
      bubbleRef[0].$props.bubbleData.content = this.bubbleStrings[
        this.getRandomInt(0, this.bubbleStrings.length - 1)
      ];
      this.$nextTick((): void => {
        bubbleRef[0].$el.style["zIndex"] = this.bubbleZIndex++;
        bubbleRef[0].$el.style["padding-top"] = this.getRandomInt(0, 15) + "%";
        bubbleRef[0].$el.style["padding-bottom"] =
          this.getRandomInt(0, 15) + "%";
        bubbleRef[0].$el.style["padding-left"] = this.getRandomInt(0, 7) + "%";
        bubbleRef[0].$el.style["padding-right"] = this.getRandomInt(0, 7) + "%";
      });
    }
  }
  private onWindowResize(): void {
    const container: HTMLCanvasElement = this.$refs
      .container as HTMLCanvasElement;
    this.renderer.setSize(container.clientWidth, container.clientHeight);

    const tRatio = this.targetWidth / this.targetHeight;
    const width = this.canvas.offsetWidth; //Window width
    const height = this.canvas.offsetHeight; //Window height
    const ratio = width / height; //Window aspect ratio

    let w = this.targetWidth * 0.5;
    let h = w / ratio;
    if (ratio < tRatio) {
      h = this.targetHeight * 0.5;
      w = h * ratio;
    }
    //-w, w, h, -h,

    this.camera.left = -w;
    this.camera.right = w;
    this.camera.top = h;
    this.camera.bottom = -h;
    //this.camera.aspect = container.clientWidth / container.clientHeight;
    this.camera.updateProjectionMatrix();
  }
}
